var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#b3';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-b3';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 658 119',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };